import { Form } from "@redriver/cinnamon-mui";
import { currenciesLookup } from "modules/lookups";

const CurrencyDropdown = (props) => (
  <Form.Dropdown lookup={currenciesLookup} search {...props} />
);

export default CurrencyDropdown;
